import { useEffect } from "react";
import "./Lightbox.css";
import { bucketUrl, getFileType } from "../utils/helper";

export default function Lightbox({ files, currentIndex, onClose, onNavigate }) {
  const file = files[currentIndex];

  // Handle ESC key to close
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNavigate(currentIndex + 1);
      if (e.key === "ArrowLeft") onNavigate(currentIndex - 1);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [currentIndex, onClose, onNavigate]);

  if (!file) return null;

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        {getFileType(file.url) === "video" ? (
          <video src={bucketUrl+file.url} controls autoPlay className="lightbox-media" />
        ) : (
          <img src={bucketUrl+file.url} alt={file.name} className="lightbox-media" />
        )}

        {/* Navigation */}
        {currentIndex > 0 && (
          <button className="lightbox-nav left" onClick={() => onNavigate(currentIndex - 1)}>
            ◀
          </button>
        )}
        {currentIndex < files.length - 1 && (
          <button className="lightbox-nav right" onClick={() => onNavigate(currentIndex + 1)}>
            ▶
          </button>
        )}

        {/* Close Button */}
        <button className="lightbox-close" onClick={onClose}>
          ✕
        </button>
      </div>
    </div>
  );
}
